import { render, staticRenderFns } from "./DataCheckList.vue?vue&type=template&id=5e64bf26&scoped=true&"
import script from "./DataCheckList.vue?vue&type=script&lang=js&"
export * from "./DataCheckList.vue?vue&type=script&lang=js&"
import style0 from "./DataCheckList.vue?vue&type=style&index=0&id=5e64bf26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64bf26",
  null
  
)

export default component.exports